import { render } from "./coreValue.vue?vue&type=template&id=02439a54"
import script from "./coreValue.vue?vue&type=script&lang=js"
export * from "./coreValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__